<template>
    <el-dialog
        title="队员信息确认"
        :visible.sync="dialogVisible"
        width="1186px"
        :destroy-on-close="true"
        class="comfirm-form"            
        >
        <div class="comfirm-info form-view">
            <el-form ref="comfirmForm" :model="comfirm_form" :rules="rules" label-width="250px">
                <el-form-item label="游戏ID" prop="account">
                    <el-input v-model="comfirm_form.account" :readonly="true" :disabled="true"></el-input>
                </el-form-item>

                <el-form-item label="游戏昵称" prop="nickName">
                    <el-input v-model="comfirm_form.nickName" :readonly="true" :disabled="true"></el-input>
                </el-form-item>

                <el-form-item label="所属军团" prop="corpName">
                    <el-input v-model="comfirm_form.corpName" :readonly="true" :disabled="true"></el-input>
                </el-form-item>

                <el-form-item label="账号历史最高神兵值" prop="maxEquipScore">
                    <el-input v-model="comfirm_form.maxEquipScore" :readonly="true" :disabled="true"></el-input>
                </el-form-item>

                <el-form-item label="真实姓名" prop="realName">
                    <el-input v-model="comfirm_form.realName"></el-input>
                </el-form-item>                             

                <el-form-item label="手机号码" prop="phone">
                    <el-input v-model="comfirm_form.phone"></el-input>
                </el-form-item>

                <el-form-item label="身份证号码" prop="idCard">
                    <el-input v-model="comfirm_form.idCard"></el-input>
                </el-form-item>
            </el-form>                                                          
        </div>

        <div class="check-view">
            <div class="v-code"><span class="tag">验证码：</span><div class="input"><input type="text" name="vcode" @blur="vcheck" v-model="vcode"></div><span class="img-box"><img v-bind:src="img"></span><span class="vcode-flesh" @click="re_code">换一个</span></div>
            <div class="check-box"><em class="box"><input type="checkbox" name="rule-check" v-model="rule_check"></em><span class="u-rule"><a href="http://www.m3guo.com/v2/news/report/1637134975.html?v=1" target="_blank">我已阅读并同意遵守《军团出征赛事规则》</a></span></div>
        </div>
        <div class="u-btn submit" @click="submitForm">确认提交</div>             
    </el-dialog>    
</template>

<style scoped>

</style>

<script>
export default {
    data () {
        return {
            dialogVisible: false,
            ua : () => {},
            comfirm_form : {
                account : '',
                nickName : '',
                corpName : '',
                equipScoreMax : '',
                realName : '',
                phone : '',
                idCard : '',
            },
            rules: this.$global.formRules,
            id : '',
            playerData : {},
            vcode : '',
            bcheck : '',
            img : this.$ajax_url_map.vcode,
            rule_check : false,
            validate : false,                  
        }
    },
    created (){
        this.id = this.playerData.id;
        this.comfirm_form.account = this.playerData.account;
        this.comfirm_form.nickName = this.playerData.nick;
        this.comfirm_form.corpName = this.playerData.corpName;
        this.comfirm_form.maxEquipScore = this.playerData.maxEquipScore;
    },
    methods : {
        vcheck (){
            if(!this.vcode)return;
            this.$axios.get(this.$ajax_url_map.vcode_check,{
                params : {
                    captcha : this.vcode,
                }
            })
            .then(res => {
                if(res.data.code == this.$ajax_code.success && res.data.data){
                    this.bcheck = true;
                }
                else{
                    this.$message.error('验证码有误');
                }                                
            });
        },
        re_code (){
            this.img = this.$ajax_url_map.vcode + '?r=' + new Date().getTime();
        },
      form_check (name){
        var self = this; 
        this.$refs[name].validate((valid) => {
          if(valid){
              self.validate = true;
          }
        });
      },
      submitForm (){

        if(!this.rule_check)return this.$message.error('请确认阅读并同意遵守军团出征赛事规则');
        if(!this.bcheck )return this.$message.error('请填写验证码');

        this.form_check('comfirmForm');

        let data = {
            "id": this.id, //玩家ID
            "account": this.comfirm_form.account, //玩家数字ID
            "realName": this.comfirm_form.realName, //真实姓名
            "phone": this.comfirm_form.phone, //手机号
            "idCard": this.comfirm_form.idCard, //身份证号码                  
        }

        if(this.validate){
            this.$axios({
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'post',
                url: this.$ajax_url_map.confirm,
                data: JSON.stringify(data)
            })
            .then(res => {
                if(res.data.code == this.$ajax_code.success){
                    this.dialogVisible = false;
                    this.$message.success(res.data.message);
                    this.$ua_update({
                        role : 2,
                        state : true,
                    });                    
                }
                else{
                    this.$message.error(res.data.message);
                }
            })
            .catch(err=>{
                this.$message.error('请稍后再试');
                console.error(err);
            })             
        }
        else{
            this.$message.error('报名信息有误，请仔细查阅报名要求');
        }
      },                       
    },
}
</script>


// WEBPACK FOOTER //
// src/components/joinModal/joinModal.vue